import React from 'react'
import Box from '@material-ui/core/Box'
import CoachProfileEmptyState from './coach-profile-empty-state'
import ProfileOverview from './profile-overview'
import { useStyles } from './styles'

const CoachProfileView = ({ coachProfile }) => {
  const classes = useStyles()
  const hasCoachProfile = coachProfile != null

  return (
    <Box className={classes.coachProfileCardsContainer}>
      {hasCoachProfile ? (
        <ProfileOverview hasCoachProfile />
      ) : (
        <Box className={classes.emptyStateContent}>
          <CoachProfileEmptyState />
        </Box>
      )}
    </Box>
  )
}

export default CoachProfileView
